import React, { useState } from 'react'
import moment from 'moment'
import { useMutation } from 'react-apollo'
import { FORM, SUBMITT_BUTTON, CANCEL_BUTTON } from 'assets/styles/globalStyles'
import { Row, Col, Form, Input, DatePicker, Button, notification, Popconfirm } from 'antd'
import { ADVANCE_INVOICE, MONTHLY_INVOICE } from './query'

const { layout, tailLayout } = FORM

function AdvanceInvoiceForm({
  form,
  selectedClinicsName,
  selectedRowKeys,
  invoiceType,
  closeDrawer,
}) {
  const [advMonth, setAdvMonth] = useState(
    invoiceType === 'advance' ? moment() : moment().subtract(1, 'M'),
  )

  const [createAdvanceInvoice, { loading: advanceLoading }] = useMutation(ADVANCE_INVOICE)
  const [createMonthlyInvoice, { loading: monthlyLoading }] = useMutation(MONTHLY_INVOICE)

  const handleSubmitt = e => {
    e.preventDefault()

    form.validateFields((error, values) => {
      if (selectedRowKeys && selectedRowKeys.length > 0) {
        if (!error) {
          if (invoiceType === 'advance') {
            createAdvanceInvoice({
              variables: {
                month: values.month?.format('MMMM'),
                clinic: selectedRowKeys,
                cgst: Number(values.cgst),
                sgst: Number(values.sgst),
                discount: Number(values.discount),
                tax: Number(values.tax),
                generateLink: false,
              },
            })
              .then(res => {
                if (res) {
                  notification.success({
                    message: 'Request sent successsfully',
                    description: 'Invoices are generating, wait for some time',
                  })
                }
              })
              .catch(err => {
                notification.error({
                  message: 'Something went wrong',
                  description: 'Unable to send request to create invoices',
                })
              })
          } else if (invoiceType === 'monthly') {
            createMonthlyInvoice({
              variables: {
                month: values.month?.format('MMMM'),
                year: values.month?.format('YYYY'),
                clinics: selectedRowKeys,
                cgst: Number(values.cgst),
                sgst: Number(values.sgst),
                discount: Number(values.discount),
                tax: Number(values.tax),
                generateLink: false,
              },
            })
              .then(res => {
                if (res.data.createMonthlyInvoiceByClinic.invoice.length) {
                  notification.success({
                    message: 'Request sent successsfully',
                    description: 'Invoices are generating, wait for some time',
                  })
                } else {
                  notification.error({
                    message: res.data.createMonthlyInvoiceByClinic.message,
                  })
                }
              })
              .catch(err => {
                notification.error({
                  message: 'Something went wrong',
                  description: 'Unable to send request to create invoices',
                })
              })
          }
        }
      } else {
        notification.warning({
          message: 'Please select at least one clinic to create invoice',
        })
      }
    })
  }

  return (
    <div>
      <Form>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item label="Month">
              {form.getFieldDecorator('month', {
                initialValue: advMonth,
                rules: [{ required: true, message: 'Please provide Month!' }],
              })(
                <DatePicker.MonthPicker style={{ width: '100%' }} onChange={e => setAdvMonth(e)} />,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Discount">
              {form.getFieldDecorator('discount', {
                initialValue: 0,
                rules: [{ required: true, message: 'Please provide Discount!' }],
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item label="CGST">
              {form.getFieldDecorator('cgst', {
                initialValue: 9,
                rules: [{ required: true, message: 'Please provide CGST!' }],
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="SGST">
              {form.getFieldDecorator('sgst', {
                initialValue: 9,
                rules: [{ required: true, message: 'Please provide SGST!' }],
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item label="Tax">
              {form.getFieldDecorator('tax', {
                initialValue: 0,
                rules: [{ required: true, message: 'Please provide Tax!' }],
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="Selected Clinics">
          <div>
            {selectedClinicsName && selectedClinicsName?.length > 0 ? (
              <div>
                <ol
                  style={{
                    display: 'flex',
                    columnGap: 30,
                    flexWrap: 'wrap',
                    paddingLeft: 25,
                  }}
                >
                  {selectedClinicsName &&
                    selectedClinicsName.map((item, index) => <li>{item.name}</li>)}
                </ol>
              </div>
            ) : (
              <b>None, Please select at least one clinic</b>
            )}
            <div>
              Create <strong>{invoiceType === 'advance' ? 'Advance' : 'Monthly'}</strong> invoice
              for selected clinics for month of <b>{advMonth.format('MMMM')}</b>.
            </div>
          </div>
        </Form.Item>
        <Form.Item {...tailLayout}>
          <Popconfirm
            title="Make sure all the filled details are correct."
            onConfirm={e => handleSubmitt(e)}
          >
            <Button
              type="default"
              loading={advanceLoading || monthlyLoading}
              style={SUBMITT_BUTTON}
            >
              Create Invoice
            </Button>
          </Popconfirm>
          <Button onClick={closeDrawer} type="ghost" style={CANCEL_BUTTON}>
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

export default Form.create()(AdvanceInvoiceForm)
